var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 14V34C42 40 39 44 32 44H16C9 44 6 40 6 34V14C6 8 9 4 16 4H32C39 4 42 8 42 14Z",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29 9V13C29 15.2 30.8 17 33 17H37",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.9603 30.9802C14.3003 28.9202 15.0802 26.3802 17.2202 25.6802C18.3602 25.3202 19.7602 25.6202 20.5402 26.7202C21.2802 25.5802 22.7402 25.3202 23.8602 25.6802C26.0202 26.3802 26.7803 28.9202 26.1403 30.9802C25.1203 34.2402 21.5402 35.9401 20.5402 35.9401C19.5602 35.9201 16.0203 34.2602 14.9603 30.9802Z",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentLike);
export default __webpack_public_path__ + "static/media/document-like.42e06b356c7bd78839d04f55577f9718.svg";
export { ForwardRef as ReactComponent };